import { JWTRole } from "@hackthenorth/north";
import { z } from "zod";

const hackerPostRsvpToolsSchema = z.object({
  isOpen: z.boolean().catch(false),
});

const defaultHackerPostRsvpTools = {
  isOpen: false,
};

export type HackerPostRsvpToolsConfig = typeof defaultHackerPostRsvpTools;

export const parseHackerPostRsvpTools = (
  value: unknown
): HackerPostRsvpToolsConfig => {
  const result = hackerPostRsvpToolsSchema.safeParse(value);

  return {
    isOpen: result.success ? result.data.isOpen : false,
  };
};

/**
 * Restrict only hackers while event-time tools are disabled. Organizers keep
 * access for development and QA, and other attendee roles remain unchanged.
 */
export const canAccessHackerPostRsvpTools = (
  roles: JWTRole[],
  isOrganizer: boolean,
  toolsEnabled: boolean
): boolean => isOrganizer || !roles.includes(JWTRole.HACKER) || toolsEnabled;
